import { useState } from "react";
import { PropagateLoader } from "react-spinners";
import DataTable from "react-data-table-component";
import { FaEye, FaFileUpload } from "react-icons/fa";
import IconButton from "../../../atoms/IconButton";
import Modal from "../../../molecules/Modal";
import NoData from "../../../molecules/NoData";
import useModal from "../../../../hooks/useModal";
import { formatCurrency } from "../../../../utils/formatCurrency";
import EditEdoCta from "./edoCuenta/EditEdoCta";
import { VIEW_FILE } from "../../../../api/apiFiles";
import { toast } from "react-toastify";
import { useSession } from "../../../../context/SessionContext";
import ModalConfirm from "../../../molecules/ModalConfirm";
import { UPDATE_EDO_CTA_STATUS } from "../../../../api/apiEdoCuenta";

const EstadoDeCuentaTable = ({ data, refetch, loading }) => {
    const { user } = useSession();
    const [fileUrl, setFileUrl] = useState(null);
    const [selected, setSelected] = useState(null);
    const [loadingView, setLoadingView] = useState();
    const { open:openUpload, isOpen:isOpenUpload, close:closeUpload } = useModal();
    const { open: openView, isOpen: isOpenView, close: closeView } = useModal();
    const { open: openResolve, isOpen: isOpenResolve, close: closeResolve } = useModal();

    const handleOpenView = async (s3Key) => {
        openView();
        setSelected(s3Key);
        setLoadingView(true);
        try {
            const response = await VIEW_FILE({ s3Key });
            if (response) {
                setFileUrl(response);
            } else {
                console.error("No se pudo obtener la URL del archivo");
            }
        } catch (error) {
            console.error("Error al cargar el archivo:", error);
            toast.error("Error al cargar el archivo");
        } finally {
            setLoadingView(false);
        }
    };

    const handleUpdate = async () => {
        setLoadingView(true);
        try {
            await UPDATE_EDO_CTA_STATUS(selected.id, { status:true, adminId:user?.id });
            toast.success("Actualizado correctamente");
            handleClose();
            refetch();
        } catch (error) {
            console.error("Error al cargar el archivo:", error);
            toast.error("Error al cargar el archivo");
        } finally {
            setLoadingView(false);
        }
    };

    const handleSelectUpload = (seleccion) => {
        setSelected(seleccion);
        openUpload();
    };

    const handleOpenResolve = (seleccion) => {
        setSelected(seleccion);
        openResolve();
    };

    const handleClose = () => {
        closeView();
        closeUpload();
        closeResolve();
        setSelected(null);
    };

    const columns = [
        {
            name: "Periodo de renta",
            cell: (row) => row.month,
        },
        {
            name: "Precio de renta",
            selector: (row) => formatCurrency(row.total),
        },
        {
            name: "Estatus",
            cell: (row) => (
                <div>
                    <button
                        className={`rounded-md p-1.5 text-white font-bold ${row.status === true ? "bg-green-500" : (row.file ? "bg-amber-400" : "bg-red-500")}`}
                        onClick={()=> handleOpenResolve(row)}
                        disabled={!row.file || row.status === true || user?.role === "Resident"}
                    >
                        {row.status === true ? "Pagado" :
                            (user?.role === "Resident" ? (row.file ? "Pendiente" : "Subir archivo") : (row.file ? "Aprobar" : "Sin archivo" ))
                        }
                    </button>
                </div>
            ),
        },
        {
            name: "Acciones",
            cell: (row) => (
                <IconButton
                    bgColor="bg-rs-azul"
                    iconSize = "text-xl"
                    size = "max-w-8 min-w-8"
                    icon={row.file ? FaEye : FaFileUpload}
                    onClick={row.file ? ()=> handleOpenView(row.file.s3Key) : ()=> handleSelectUpload(row)}
                    disabled={user?.role !== "Resident" && !row.file}
                />
            ),
        },
    ];

    return (
        <>
            <DataTable
                data={data}
                progressPending={loading}
                columns={columns}
                progressComponent={ <div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div> }
                noDataComponent={<NoData />}
                pagination
            />
            {isOpenUpload && selected &&
                <Modal title="Subir comprobante" onClose={handleClose}>
                    <EditEdoCta edoCta={selected} refetch={refetch} onClose={handleClose} />
                </Modal>
            }
            {isOpenView && selected &&
                <Modal title="Comprobante de pago" onClose={handleClose}>
                    {loadingView ?
                            <PropagateLoader color="red" />
                        :
                            <iframe src={fileUrl} title="Factura" className="w-full h-[85vh]" />
                    }
                </Modal>
            }
            {isOpenResolve && selected &&
                <ModalConfirm onClose={handleClose} onConfirm={handleUpdate} loading={loadingView} />
            }
        </>
    );
};

export default EstadoDeCuentaTable;